export default function Footer() {
  const goAnchor = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-background-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-12 md:pt-16 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <a
              href="#top"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <span className="w-9 h-9 rounded-2xl bg-primary-500 flex items-center justify-center text-lg">🍉</span>
              <span className="font-heading text-xl text-background-50">吃瓜频道</span>
            </a>
            <p className="text-background-300 text-sm leading-relaxed mt-4">
              边播边聊的在线围观现场，弹幕实时讨论、连麦观点碰撞，和所有吃瓜群众一起蹲后续、追反转。
            </p>
            <div className="flex items-center gap-2.5 mt-5">
              <a
                href="#top"
                aria-label="微博"
                className="w-9 h-9 rounded-full bg-background-800/70 hover:bg-primary-500 flex items-center justify-center text-background-200 text-lg transition-colors cursor-pointer"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href="#top"
                aria-label="视频号"
                className="w-9 h-9 rounded-full bg-background-800/70 hover:bg-primary-500 flex items-center justify-center text-background-200 text-lg transition-colors cursor-pointer"
              >
                <i className="ri-vidicon-line"></i>
              </a>
              <a
                href="#top"
                aria-label="抖音"
                className="w-9 h-9 rounded-full bg-background-800/70 hover:bg-primary-500 flex items-center justify-center text-background-200 text-lg transition-colors cursor-pointer"
              >
                <i className="ri-music-2-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">快速围观</h4>
            <ul className="space-y-3">
              {[
                { id: "live", label: "直播现场" },
                { id: "hot", label: "今日热榜" },
                { id: "danmaku", label: "弹幕现场" },
                { id: "connect", label: "连麦吃瓜" },
                { id: "column", label: "话题分类" },
              ].map((l) => (
                <li key={l.id}>
                  <a
                    href={`#${l.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      goAnchor(l.id);
                    }}
                    className="text-background-300 hover:text-background-50 text-sm transition-colors cursor-pointer"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">了解更多</h4>
            <ul className="space-y-3">
              <li>
                <a href="#faq" onClick={(e) => { e.preventDefault(); goAnchor("faq"); }} className="text-background-300 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  常见问题
                </a>
              </li>
              <li>
                <a href="#faq" onClick={(e) => { e.preventDefault(); goAnchor("faq"); }} className="text-background-300 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  社区规范
                </a>
              </li>
              <li>
                <a href="#faq" onClick={(e) => { e.preventDefault(); goAnchor("faq"); }} className="text-background-300 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  加入主播
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">联系我们</h4>
            <ul className="space-y-3 text-background-300 text-sm">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                hi@chiagua.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-400"></i>
                在线围观 · 24 小时不打烊
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-shield-check-line text-primary-400"></i>
                理性吃瓜 · 尊重事实
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-background-800/70 mt-10 pt-6 text-background-400 text-xs">
          <p className="whitespace-nowrap">© 2026 吃瓜频道 · 边播边聊，蹲后续也蹲得到反转</p>
          <p className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-chat-smile-3-line text-primary-400"></i>
            理性吃瓜，快乐冲浪
          </p>
        </div>
      </div>
    </footer>
  );
}